<template lang="pug">
  .app#app
    router-view
</template>

<script>
export default {
  computed: {
    isLogin () {
      return this.$store.getters.isLogin;
    },
  },
  created () {
    if (window.location.search) {
      window.location.replace(`${window.location.origin}${window.location.pathname}${window.location.hash}${window.location.search}`)
    }

    this.$store.watch(({ loginStatus }) => {
      if (loginStatus === null) {
        this.$router.replace({ path: '/login', query: this.$route.query });
        setTimeout(() => {
          location.reload();
        }, 1 * 1000);
      }
    });
  },
}
</script>

<style lang="less">
@import './assets/general.less';
@import "../node_modules/mint-ui/lib/style.css";

html {
  height: 100%;
  font-size: 100px;
  @media (-webkit-min-device-pixel-ratio: 2) {
    font-size: 100px/2;
  }
  @media screen and (max-width: 370px) {
    font-size: 100px/2 * 0.85;
  }
  @media screen and (min-width: 414px) {
    font-size: 100px/2 * 1.1;
  }
  @media screen and (min-width: 480px) {
    font-size: 100px/2;
  }
}

body {
  box-sizing: border-box;
  height: 100%;
  margin: 0;
  padding: 0;

  font-family: "Helvetica Neue", Helvetica, Arial, "Microsoft Yahei",
    "Hiragino Sans GB", "Heiti SC", "WenQuanYi Micro Hei", sans-serif;
  font-size: 0.32rem;

  background: #f0f1f5;
  background-size: 100%;
}
button,
input,
select,
textarea {
  font-family: "Helvetica Neue", Helvetica, Arial, "Microsoft Yahei",
    "Hiragino Sans GB", "Heiti SC", "WenQuanYi Micro Hei", sans-serif;
  outline: none;
}

.app {
  height: 100%;
}

.icon {
  background-position:  center center;
  background-repeat:    no-repeat;
  background-size:      contain;
}
.logo {
  width:      .9rem;
  height:     .9rem;
  background-image: url('./assets/logo.png');
}
.add-icon {
  width:      .72rem;
  height:     .72rem;
  background-image: url('./assets/add.png');
}
.bind-icon {
  .icon;
  width:      .96rem;
  height:     .40rem;
  background-image: url('./assets/bind.png');
}
.search-white-icon {
  .icon;
  width:      .48rem;
  height:     .48rem;
  background-image: url('./assets/search-white.png');
}

.createWallet-icon {
  width:      3.6rem;
  height:     3.6rem;
  background-image: url('./assets/createWallet.png');
}
.user-icon {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABmUExURUxpcfPz8/X19fj4+O/v7/Pz8/b29uzs7Pb29vj4+PHx8fj4+PHx8fDw8PT09P////Pz8/X19fj4+O7u7szMzPX19e7u7vf398fHx+jo6PPz883Nzd7e3tHR0dTU1NnZ2eTk5MrKyhc91vgAAAAWdFJOUwBhjezsfzf+/g/HG9FU3wNzq9SljiqQMu7+AAACuUlEQVRYw51X2ZasIAx0h3Zr7ZmDscGF///Ji2hPowTFW48eUiZQKUgQOFBUaVvWMaVxXbZpVQS3kEWv7oBXlPlGPxoreuNoHj7hadw5EaeXFOFJuKYIT8OLvLtEfrKfWdx5IHbuZkg7L1C8jGfUeSN6IvFtdwOtzRB1txBZ9Xc3cdiH7H2XgO7OokgYu0sRm3rI2QJ6jyE3NoCteNP/24ZHwj64VUf86ayUGbiTRGolcLOOLYWGHfBXBxEDl3wUzMXQaIKSMZSi5/DB6KB4aQ0xDJROAFyQ9/vdTxJA4AyLmiKUgHCQ82fZWwBMzpYoUYIBODEW9hLPQdXwQOMnkGSnCgJAMIYiqNACJMwHVQgYMIJqr6JvAuNRFZSjKaTBD0bAtwRMVQh0H9utEffoQdrCYsARgjKoEYIZhoMqlrUAiMjrIEEIxN8WmA3CAenVOCBeBEsdEiOgKIFVggYAZo1oCYtqMFaKlVDjQhbWtxEmxLBq9BjVJnD7aKFHPK/EhaSUNFlJTZjntbiUVcGHItbusj0vxZtpKcJkICMY4jbrqBztrBn4FkOEVO6C22bhMhRVhTIyOU5iUn+HoUekuZlixFwMhqn2iPHSzdJwU51HCSb4NGPenTlsXUgdI+ZeYRZCs3Gb4oVfLEs4F/ustbfzYyUNdrWRAf3ZyruXV/JALld1H0mB7ypRd81gdllqX+/L4fGeMffRcmIl8H1g6BUjO4G6sL4M4fGJo/K/iNcMH7PJD4+stQkv4vWds65Jdo/ujKwtx8kVwZLlckbk8OQO1x7u2TWE7mzrwR0ZnnGBZV2EPLbnr2ecQy1ssef6Lwjmh/H3iU4MlV8CjDjnpizxiU+ys6HrOj4/H2LDiySS8HrwPKFIUq/ZtXH4bOk1+m7Dt8VR+g/fWx5V+pPXCSFJnf+klfPf/wDAVhmuAjPFDQAAAABJRU5ErkJggg==);
  width:  .64rem;
  height: .64rem;
}
.question-icon {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABLUExURUxpcf///////////////////////////////////////////////////////////////////////////////////////////////1SsvH4AAAAYdFJOUwDNQKyWJsAFGPTe8eV9R4LHDDgT2VktbAx3QVsAAAElSURBVDjLhVNZloQgDERFkEXc7br/SQdlC23PMz9KCJWqLIxlk46LXaldcCfZ0wZukM3w4etaTgpoxrZflr4dG0BNFcowA11fzn0HzATktNBrDblq2DO/txDbN6dNwEYMOUP8oC0F5uCeoLcfstimMd0JFNYstVG6azMPqCsJRxcdh4GdNcBTRHf9SoOor1fq8J/W4khqYSRzaHL8GICyhzVwPsMYTxpB1gCVRI0+h0AipRD8ZwloIdieKLAh1oV7byax+3dLLf+DjMkWqEfAAXxYCTAkRcxK7u8UhWQUNlXhgsgMCgzNeMkshQoMuhrPkVJf5gTFu0tNmvWwu1m03f7N4cjYhXZXA/MhjNLAVCNHAsrIvQ7t+9i/L8776r0v7//r/wcwSBS+07KOTgAAAABJRU5ErkJggg==);
  width:  .28rem;
  height: .28rem;
}
.card-icon {
  .icon;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAgBAMAAACbaIdJAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURUxpcWp6jz+E62ZziWZ0iWV0imVziTuK/9lHMdcAAAAGdFJOUwActemntR1kRbgAAABISURBVCjPY2B0TsMAJgIMwmlYgCGDWyADBhBNYTATwBRmTGZIY8AC0qgkXI4F4BYeGS6hm7ASGBIrTMhsHMkHR2LDkTSxJ2QAnR9ccfykM4gAAAAASUVORK5CYII=);
  width:  .44rem;
  height: .32rem;
}
.extract-icon, .money-icon {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAB1UExURUxpcW2Alml1i2d0i2d0i2d1i2d0i2d1i0KS/zuK/zyL/2Z1i2p4jml2jWd2izyL/zyL/zyL/zyL/zyL/2Z1i2d0i2h5i2Z0i2d2i256kGd1ijuL/zyL/0CS/2Z0iz2K/zuK/2Z0izyM/zyN/zyL/2Z0ijuK/xMu8DUAAAAldFJOUwALQsKr6vSCDvg73CM3cue5mddXU9As/I4Xmn3FHFppvn1qJr8EGi1XAAAB/UlEQVQ4y5VV15arMAwUuGADCYSeRqr0/5+4Irt0cu/xPDixEWZmJMsAC+wCKSKtIyGDHfwT/knhBOrkfw3dCQ6ImtaPPS/22ybiqdjePpa81aOaLlUP/pCMNxgo1IEHYPLDO7M2ex9yA+AFGtWKy75GeQTI75YG2HsOcJRY7+exDWIAEF44In2GL2Ne4TPl9y4hQIDYzPZFXQAciJKbGVfNLSE6ABQaJ3v7NRZgUrJnM/+gOVtKDRRYD7xjxRxMRkm41h0mlBlmonpPJEqAlLLrlqPXjNK/kE8uUB+Zb3LdTtU1Yd5Hjb/ZEUwiJBt+S2xoKWQi4qMOlQcXOn+vmDNdwFPYaTzhA3JKeh9kXfXsTr0nCeXw+EwVVnCn22CNFr9/BCv5w43uUKHqNojAWDsaHLDnjHaSiM/ziCUGnMu8c6eHF0VcT54qJ6xT5tGwDxJb9u05eVJ0ZRLgtNae7F7LVgtefdPMN6njWMuZe/Rm1wRTiSGj1+wYaClHdR1elEHM4jR6YGnUV5RlqRE1/xSjQrLgoV4FV3uGUt1YrYI3aABE5Xze01gK3AUMpbqxWglcWlcIhtbd6K+sWyVli0aflFW6N4KHdC8LaSt4KKRliW4ET0rUqfidjpXbgXVqBW5Nxql9uTVGt5br1szdrgm3C8jtanO8NP97Hf8AT00/5WNaZ9YAAAAASUVORK5CYII=);
  width:  .44rem;
  height: .44rem;
}

.small-title {
  padding:  1em;
  .small;
  background:   transparent;
  .grey;
}

.warning {
  background: @background-grey-2;
  color:      @font-color-orange-dark;
}

.wide-button {
  .border-box;
  width:          e("calc(100% - .8rem)");
  background:     @font-color-blue-2;
  color:          @white;
  font-size:      .32rem;
  margin:         .4rem;
}

.inline-button {
  background:     @font-color-blue-2;
  color:          @white;
}

///////////////////////////////////////////

.mint-header {
  height:         0.96rem;
  background:     @white;
  color:          @black;
  margin-bottom:  1em;

  .is-left .mint-button {
    .align-left;
    color:      @font-color-blue-2;
    border:     none;
  }
  .is-right .mint-button {
    .align-right;
    color:      @font-color-blue-2;
    border:     none;
  }
}
.mint-header-title {
  .bold;
  font-size:    0.36rem;
  color:        @black;
}

.mint-cell+.mint-cell {
  .mint-cell-wrapper {
    border-top:   .02rem solid #999;
  }
}

.mint-cell-title {
  font-size:    .28rem;

}

///////////////////////////////////////////

.black {
  color: #222;
}
.grey {
  color: #999;
}
.blue {
  color: #41a3ff;
}
.small {
  font-size: 0.24rem;
}
.tiny {
  font-size: 0.2rem;
}
.big {
  font-size: 0.32rem;
}
.bold {
  font-weight: bold;
}

.box-divide {
  .max-width;
  margin:   .5em 0;
  border:   .03rem solid @hr-grey;
}

.container-copyright {
  .align-center;
  font-size:  .2rem;
  color:      @font-color-grey;
}
</style>



// WEBPACK FOOTER //
// src/App.vue